// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4352":"1b08c3f2","4657":"cd344330","5468":"1b08c3f2","6422":"1b08c3f2"}[chunkId] + ".chunk.css";
};